import { apiFetch } from "./api"

const ENDPOINT = "/api/client/reliability_metrics"
const REPORT_THROTTLE_MS = 30_000
const MAX_SCOPES = 200
const lastReportedAt = new Map()

// Browser-side counterpart to the native client diagnostics seam. Always keep
// the local console breadcrumb; send one privacy-safe, bounded event per scope
// and throttle window so a failing poll cannot amplify an outage.
export function logEvent(scope, error = null, context = {}) {
  console.warn(scope, error ?? context)

  const now = Date.now()
  if (!reportingAvailable() || !shouldReport(scope, now)) return Promise.resolve(false)

  const payload = {
    metrics: [{
      key: metricKey(scope),
      count: 1,
      last_at: new Date(now).toISOString(),
      error: errorPayload(scope, error, context)
    }],
    context: { source: "web" }
  }

  try {
    return Promise.resolve(apiFetch(ENDPOINT, {
      method: "POST",
      keepalive: true,
      body: JSON.stringify(payload)
    })).then((response) => response.ok).catch(() => false)
  } catch {
    return Promise.resolve(false)
  }
}

function reportingAvailable() {
  return typeof fetch === "function" &&
    typeof document !== "undefined" &&
    typeof document.querySelector === "function" &&
    !!document.querySelector('meta[name="csrf-token"]')?.content
}

function shouldReport(scope, now) {
  const key = String(scope || "client.unknown").slice(0, 100)
  const last = lastReportedAt.get(key)
  if (last != null && now - last < REPORT_THROTTLE_MS) return false
  if (lastReportedAt.size >= MAX_SCOPES) lastReportedAt.delete(lastReportedAt.keys().next().value)
  lastReportedAt.set(key, now)
  return true
}

function metricKey(scope) {
  return String(scope || "client_unknown")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80) || "client_unknown"
}

function errorPayload(scope, error, context) {
  const value = error instanceof Error ? error : null
  return {
    name: String(value?.name || "ClientEvent").slice(0, 80),
    message: String(value?.message || error || "Browser client event").slice(0, 220),
    ...(Number.isFinite(Number(value?.status)) ? { status: Number(value.status) } : {}),
    context: {
      scope: String(scope || "client.unknown").slice(0, 120),
      ...(Number.isFinite(Number(context?.failures)) ? { failures: Number(context.failures) } : {}),
      ...(context?.reason != null ? { reason: String(context.reason).slice(0, 120) } : {}),
      ...(Number.isFinite(Number(context?.status)) ? { status: Number(context.status) } : {})
    }
  }
}

export function resetClientLoggerForTests() {
  lastReportedAt.clear()
}
